import './App.css';
import 'aos/dist/aos.css';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home.js';
import Projects from './pages/Projects.js';
import Experience from './pages/Experience.js';
import About from './pages/About.js';
import Education from './pages/Education.js';
import Skills from './pages/Skills.js';
import Blogs from './pages/Blogs';
import Footer from './components/Footer.js';
import ScrollToTop from "./components/ScrollToTop";
import Navbar from './components/Navbar.js';
import VoiceAssistant from './components/VoiceAssistant.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route
          path="/"
          element={
            <div className="home site-main">
              <Home />
              <About />
              <Experience />
              <Education />
              <Projects />
              <Skills />
            </div>
          }
        />
        <Route path="/blogs" element={<Blogs />} />
      </Routes>

      <Footer />
      <VoiceAssistant />
    </>
  );
}

export default App;
